import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';

import Layers, { LAYER_TYPES, SPATIAL_FOR_JOIN_SUBTYPES } from '../../../api/Layers/Layers';
import MapServerElements, {
  getLayerTypesForLayerServerType
} from '../../../api/MapServerElements/MapServerElements';
import {
  isDeleted,
  getMapServerUrl,
  getName,
  getType
} from '../../../api/MapServerElements/map-server-element-operations';

import LayerEditor from '../../components/LayerEditor';
import Loading from '../../components/Loading';
import NotFound from '../NotFound';

import PageHeader from '../../atoms/PageHeader';

const NewLayerFromMapServerElement = ({
  mapServerElement,
  history,
  match,
  loading,
  isFree,
  isBasic,
  geojsonLayers,
  thematicLayers,
  deployConfig,
  userControlSetting
}) => {
  if (loading) {
    return <Loading />;
  }
  if (isDeleted(mapServerElement)) {
    return <NotFound />;
  }
  const mapServerElementType = getType(mapServerElement);
  const layer = {
    name: getName(mapServerElement),
    url: getMapServerUrl(mapServerElement),
    ...getLayerTypesForLayerServerType(mapServerElementType)
  };
  return (
    <>
      <PageHeader>
        <h4>New Layer</h4>
      </PageHeader>
      <LayerEditor
        layer={layer}
        history={history}
        isFree={isFree}
        isBasic={isBasic}
        match={match}
        thematicLayers={thematicLayers}
        geojsonLayers={geojsonLayers}
        deployConfig={deployConfig}
        userControlSetting={userControlSetting}
      />
    </>
  );
};

NewLayerFromMapServerElement.defaultProps = {
  mapServerElement: {},
  geojsonLayers: [],
  thematicLayers: [],
  userControlSetting: {}
};

NewLayerFromMapServerElement.propTypes = {
  mapServerElement: PropTypes.object,
  thematicLayers: PropTypes.array,
  geojsonLayers: PropTypes.array,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  deployConfig: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  isFree: PropTypes.bool.isRequired,
  isBasic: PropTypes.bool.isRequired,
  userControlSetting: PropTypes.object
};

export default withTracker(({ match }) => {
  const layerSub = Meteor.subscribe('layers');
  const mapServerElementId = match.params.mapServerElement_id;
  const mapServerElementsSub = Meteor.subscribe('mapServerElements.view', mapServerElementId);
  return {
    loading: !mapServerElementsSub.ready() || !layerSub.ready(),
    mapServerElement: MapServerElements.findOne(mapServerElementId),
    geojsonLayers: Layers.find({
      deleted: { $eq: 'no' },
      layerType: { $eq: LAYER_TYPES.SPATIAL },
      layerSubType: { $in: SPATIAL_FOR_JOIN_SUBTYPES }
    }).fetch(),
    thematicLayers: Layers.find({
      deleted: { $eq: 'no' },
      layerType: { $eq: LAYER_TYPES.THEMATIC }
    }).fetch()
  };
})(NewLayerFromMapServerElement);
